export * from './src/active-promotion-section';
